import styled, { themeGet, device, css } from "@styled";

export const SectionWrap = styled.section`
    padding-block-start: 20px;
    padding-block-end: 30px;
    overflow: hidden;
    border-block-end: 1px solid ${themeGet("colors.border")};
    ${device.medium} {
        padding-block-start: 30px;
        padding-block-end: 40px;
    }
    ${device.large} {
        padding-block-start: 40px;
        padding-block-end: 50px;
    }

    ${() =>
        css`
            a {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                text-decoration: none;
                color: #333333;
                text-align: center;
                ${() =>
                    css`
                        .brand-logo__image {
                            visibility: visible;
                            &-hover {
                                visibility: hidden;
                                transition: all 1s linear;
                                position: absolute;
                                left: 50%;
                                top: 0;
                                margin-left: -40px;
                            }
                        }
                        &:hover {
                            .brand-logo__image {
                                visibility: hidden;
                                &-hover {
                                    opacity: 1;
                                    visibility: visible;
                                }
                            }
                        }
                    `}
            }
        `}
`;

export const SubTitle = styled.h5`
    font-size: 14px;
    color: #ababab;
    font-weight: normal;
    text-align: center;
    padding-block-end: 20px;
`;
